module.exports = __webpack_public_path__ + "media/images/expand-less-343decc7.svg";